import React, {useState, useEffect, useRef} from 'react';
import { Col, Row } from 'react-grid-system';
import { useForm } from "react-hook-form";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { addAlertToDOM } from '../../helpers/util';
import { useSelector } from 'react-redux';

const AddEditRightModal = props => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const modalContentRef = useRef(null);
  const {modalTimeout} = useSelector(state => state.util);
  
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: { 
      name: '',
      status: true,
    }
  });
  const {isAdd = true, visible = false, width = 650, data, onSubmit, onCancel} = props;

  useEffect(() => {
    if(!isAdd) {
      const {label = '', status = ''} = data ?? {};
      setValue('name', label);
      setValue('status', status == 1);
    } else reset({ 
        name: '',
        status: true,
    });
  }, [data]);

  useEffect(() => {
    if (!visible) {
      document.body.style.overflow = 'unset';
      return;
    }

    document.body.style.overflow = 'hidden';

    document.addEventListener('click', hideDropdownMenu);
    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('click', hideDropdownMenu)
    };
  }, [visible]);

  const hideDropdownMenu = event => {
    if (modalContentRef && modalContentRef?.current?.contains(event.target) === false) {
      onCancel && onCancel();
    }
  };

  const closeModal = e => {
    e && e.stopPropagation();
    onCancel && onCancel();
  };

  const handleCancel = e => {
    if(onCancel){
        reset({ 
            name: '',
            status: true,
        });
        onCancel(e);
    }
  };

  const submitData = ({name, status}) => {
    setSubmitLoading(true);
    let reqPayload = { 
        "id": name,
        "key": name,
        "label": name,
        "status": status === true ? 1 : 0
    };

    if(!isAdd){
      const {id = '', key = ''} = data ?? {};
      reqPayload.id = id;
      reqPayload.key = key;
    }

    axios.post(isAdd ? '/api/v1/rights/add' : '/api/v1/rights/edit', reqPayload).then(response => {
        console.log(response);
        if(response.status === 200){
            addAlertToDOM('.add-right-modal .um-modal-body', 'success', `Right ${isAdd ? 'added' : 'updated'} successfully`, 'mb-15');
            onSubmit && setTimeout(() => {
                onSubmit();
                reset({ 
                    name: '',
                    status: false,
                });
            }, modalTimeout);
        } else addAlertToDOM('.add-right-modal .um-modal-body', 'warning', 'Something went wrong. Try again.', 'mb-15');
    }).catch(errors => {
        console.log(errors.response);
        addAlertToDOM('.add-right-modal .um-modal-body', 'warning', 'Something went wrong. Try again.', 'mb-15');
    }).finally(() => setSubmitLoading(false));
  }

  useEffect(()=>{
		if (window?.umApp?.DoOverrideAddEditRightModalComponent) {
				window?.umApp?.DoOverrideAddEditRightModalComponent();
			}
	},[])

  const modalContentStyles = {maxWidth: width};

  return (
      <div className={ `add-right-modal um-modal ${visible ? 'show' : 'hide'}`}>
        <div className="um-modal-content" style={modalContentStyles} ref={modalContentRef}>
          <div className="um-modal-header">
            <p className="um-modal-header-text">{isAdd ? 'Add Right' : 'Edit Right'} <span className="close" onClick={closeModal}>&times;</span></p>
          </div>
          <div className="um-modal-body">
            <form  onSubmit={submitLoading?()=>{}:handleSubmit(submitData)} noValidate>
                <Row>
                    <Col xs={6} className="mb-20">
                        <input
                            name="name"
                            type="text"
                            className="um-input full-width"
                            placeholder="Right Name"
                            {...register("name", {
                                required: true,
                            })}
                        />
                        { errors?.name?.type === 'required' && <p className="validation-error">Right name is required</p> }
                    </Col>
                    <Col xs={6} className="mb-20">
                        <div className="checkbox-wrapper">
                            <input
                                id="status"
                                name="status"
                                type="checkbox"
                                {...register("status")}
                            />
                            <label className="cursor-pointer" htmlFor="status">Enable</label>
                        </div>
                    </Col>
                    <Col xs={12} className="text-right">
                        <button
                            type='submit'
                            className="um-button um-button--primary mr-10"
                        >
                            {
                                submitLoading ? (
                                    <span>
                                        <FontAwesomeIcon
                                            className="loading-icon mr-5"
                                            icon={faSpinner}
                                            spin
                                        />
                                        Submit
                                    </span>
                                ) : 'Submit'
                            }
                        </button>
                        <button
                            type='reset'
                            className="um-button"
                            onClick={handleCancel}
                        >Cancel
                        </button>
                    </Col>
                </Row>
            </form>
          </div>
        </div>
      </div>
  );
};

export default AddEditRightModal;
